import Route from '@ember/routing/route';

export default class RequestCodeRoute extends Route {
}
